export default __webpack_public_path__ + "static/media/easecom.de7c46c5.png";